// extracted by mini-css-extract-plugin
export default {"toolButton":"HelpPanel_toolButton__5yVp5","info":"HelpPanel_info__IiFl+","pointsInfo":"HelpPanel_pointsInfo__C64ED"};